import extend from "node.extend";
import customConfig from '../../custom/config';

let config = {
  version:'1.0.0',
  perPage: 16,
  cid: 1,
  api: 'http://test.sosho.cn/server/api/',
  mw: 'http://test.h5.sosho.cn/',
  ids: {
    customize_nav: 157,
    introduce: 66,
    donate_community: 543,
    donate_method: 69,
    donate_project: 130,
    friendlyLink: 128,
    home_picture: 124,
    notice: 131
  },
  footer:''
};

extend(true, config,customConfig);

config.mwUrl = {
  activity: config.mw + 'activity/detail.html?id=',
  community: config.mw + 'community/detail.html?id='
};
export default config;



// WEBPACK FOOTER //
// ./src/unit/config.js